// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSuccess_root__3dKwr","fillColor":"IconSuccess_fillColor__5uuwi"};